import { tryParseJSONObject } from '@fox/atoms/utils/string';
import { QuestionBlockMetadata } from '../contracts';
import { IRenderDataTableQuestionProps } from './data-table/helpers';
import { RenderCustomFieldDataTableQuestion } from './data-table/render-custom-field-data-table';
import { RenderFormOnlyDataTableQuestion } from './data-table/render-form-only-data-table';

export const RenderDataTableQuestion = ({ id, fieldProps }: IRenderDataTableQuestionProps) => {
	const fieldMeta = tryParseJSONObject<QuestionBlockMetadata>(fieldProps.metadataJson, {});

	if (fieldMeta.dataTableType == 'formOnly') {
		return <RenderFormOnlyDataTableQuestion id={id} fieldProps={fieldProps} />;
	}
	if (fieldMeta.dataTableType == 'customField') {
		return <RenderCustomFieldDataTableQuestion id={id} fieldProps={fieldProps} />;
	}
};
